const LEGAL_PATHS = new Set([
  "/privacy.html",
  "/terms.html",
  "/support.html",
  "/account-deletion.html",
  "/editorial-source-policy.html",
  "/financial-disclaimer.html",
]);

/** Legal language follows the reader, never the selected news edition or residence. */
export function localizedLegalPath(path, locale) {
  const language = String(locale || "")
    .toLowerCase()
    .split(/[-_]/)[0];
  if (!["de", "fr", "ja"].includes(language)) return path;
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return path;
  try {
    const url = new URL(path, "https://todaysbrief.app");
    if (url.origin !== "https://todaysbrief.app" || !LEGAL_PATHS.has(url.pathname)) return path;
    return `/${language}${url.pathname}${url.search}${url.hash}`;
  } catch {
    return path;
  }
}
